import { useEffect, useState, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Close, Cogwheel } from '../Icons';
import { Ratio } from '../Ratio';
import css from './styles.module.css';

export const Settings = ({
  cupSize,
  setCupSize,
  customRatio,
  setCustomRatio,
  setRatio,
}) => {
  const [showError, setShowError] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  const contentRef = useRef();
  const outsideRef = useRef();

  useEffect(() => {
    const customCupSize = localStorage.getItem('customCupSize');
    const customRatio = localStorage.getItem('customRatio');

    if (customCupSize !== null && !isNaN(customCupSize)) {
      setCupSize(customCupSize);
    }

    if (customRatio !== null && !isNaN(customRatio)) {
      setCustomRatio(customRatio);
    }
  }, [setCupSize, setCustomRatio]);

  const handleMenuToggle = () => {
    const body = document.body;
    const scrollbarWidth = window.innerWidth - body.clientWidth;

    setShowSettings(!showSettings);

    body.style.height = showSettings ? 'auto' : '100vh';
    body.style.overflow = showSettings ? 'visible' : 'hidden';
    body.style.marginRight = showSettings ? '0px' : `${scrollbarWidth}px`;
  };

  const handleCupChange = e => {
    if (showError) {
      setShowError(false);
    }
    const number = e.target.value;

    if (number === '') {
      setCupSize(0);
      setStorage('customCupSize', 0);
    }

    const parsedNumber = parseInt(number, 10);

    if (!isNaN(parsedNumber)) {
      setCupSize(parsedNumber);
      setStorage('customCupSize', parsedNumber);
    }
  };

  const handleBlur = () => {
    if (
      cupSize === 0 ||
      cupSize === null ||
      cupSize === undefined ||
      isNaN(cupSize)
    ) {
      setDefaultCupSize();
      setShowError(true);

      setTimeout(() => {
        setShowError(false);
      }, 3000);
    }
  };

  const setDefaultCupSize = () => {
    setCupSize(125);
    setStorage('customCupSize', 125);
  };

  const setStorage = (id, amount) => {
    localStorage.setItem(id, amount);
  };

  const handleRatioChange = e => {
    const ratio = e.target.value;

    if (ratio === '') {
      setCustomRatio(0);
      setStorage('customRatio', 0);
    }

    const parsedRatio = parseInt(ratio, 10);

    if (!isNaN(parsedRatio)) {
      setCustomRatio(parsedRatio);
      setStorage('customRatio', parsedRatio);
    }
  };

  return (
    <section className={css.main}>
      <button
        aria-label="Vis instillinger"
        className={css.button}
        onClick={handleMenuToggle}
      >
        {showSettings ? <Close /> : <Cogwheel />}
      </button>
      <CSSTransition
        in={showSettings}
        timeout={300}
        classNames={{ ...css }}
        nodeRef={contentRef}
        unmountOnExit
      >
        <div ref={contentRef} className={css.content}>
          <div className={css.inner}>
            <p>Styrkene er ment for trakterkaffe.</p>
            <p>For presskanne anbefaler jeg rundt 1:12.</p>
            <div className={css.inputField}>
              <label htmlFor="customRate">Egen styrke</label>
              <input
                value={customRatio}
                id="customRate"
                name="customRate"
                className="number"
                type="text"
                inputMode="decimal"
                pattern="[0-9]*"
                onChange={handleRatioChange}
              />
            </div>
            <div className={css.inputField}>
              <label htmlFor="Kop størrelse">Koppstørrelse</label>
              <input
                onBlur={() => handleBlur(cupSize)}
                value={cupSize}
                onChange={handleCupChange}
                id="Kop størrelse"
                name="Kop størrelse"
                className="number"
                type="text"
                placeholder="125"
                inputMode="decimal"
                pattern="[0-9]*"
              />
              ml
              {showError && (
                <p className={css.error}>
                  Kan ikke være <span className="number">0</span>
                </p>
              )}
            </div>
            <Ratio customRatio={customRatio} setRatio={setRatio} />
          </div>
        </div>
      </CSSTransition>
      {
        <CSSTransition
          in={showSettings}
          timeout={300}
          classNames={{ ...css }}
          nodeRef={outsideRef}
          unmountOnExit
        >
          <div
            ref={outsideRef}
            onClick={handleMenuToggle}
            className={css.outside}
          />
        </CSSTransition>
      }
    </section>
  );
};
